import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class InputLimitationService {
  private grooveLimitations;
  private oringLimitations;
  constructor(private http: HttpClient) {}

  private grooveLimitationData() {
     this.grooveLimitations = this.http.get('assets/calculations-json/InputLimitations.json');
  }

  private oringLimitationData() {
    this.oringLimitations = this.http.get('assets/calculations-json/OringInputRanges.json');
  }

  getGrooveLimitations() {
    if (!this.grooveLimitations) {
      this.grooveLimitationData();
    }
    return this.grooveLimitations;
  }

  getOringLimitations() {
    if (!this.oringLimitations) {
      this.oringLimitationData();
    }
    return this.oringLimitations;
  }
}



// WEBPACK FOOTER //
// /var/www/asna/front-end/public_html/src/app/service/InputLimitationService.ts